export function * forwards (array, step = 1, start = 0) {
  for (let index = start; index < array.length; index += step) {
    yield array[index]
  }
}

export function * backwards (array, step = 1, start = 0) {
  const startIndex = lastIndex(array) - start
  for (let index = startIndex; index >= 0; index -= step) {
    yield array[index]
  }
}

export function first (array) {
  return array[0]
}

export function lastIndex (array) {
  return (array.length - 1)
}

export function last (array) {
  if (array.length === 0) {
    return undefined
  }
  return array[array.length - 1]
}

export function previous (array, index) {
  if (index > 0) {
    return array[index - 1]
  }
  return undefined
}

export function previousOrFirst (array, index) {
  return previous(array, index)
      || first(array)
}

export function next (array, index) {
  if (index < array.length - 1) {
    return array[index + 1]
  }
  return undefined
}

export function nextOrLast (array, index) {
  return next(array, index)
      || last(array)
}

export function isOutside (array, index) {
  return index < 0
      || index >= array.length
}

export function isInside (array, index) {
  return !isOutside(array, index)
}

export default {
  forwards,
  backwards,
  first,
  last,
  previous,
  previousOrFirst,
  next,
  nextOrLast,
  isOutside,
  isInside
}
